(function ($) {
    var $el = $('[data-admin-email]');
    for (var i = 0; i < $el.length; i++) {
        $($el[i]).on('click', function() {
            $($(this).data('target')).overlay();
            loadAPI($(this).data('order-id'), $(this).data('user-id'), $(this).data('target'), $(this));
        });
    }
}(jQuery));

function loadAPI(orderId, customerId, overlayId, $triggerEl) {
    var url = '/api/commerceadminorder/sendorderemail';
    var data = {
        'OrderId': orderId,
        'CustomerId': customerId
    };
    $(overlayId).find('.c-spinner').show();
    $(overlayId).find('.h-response-message--success').hide();
    $(overlayId).find('.h-response-message--error').hide().find('p').remove();
    $(overlayId).find('.c-overlay__close').hide();
    setTimeout(() => {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: (response) => {
                $(overlayId).find('.c-spinner').hide();
                $(overlayId).find('.c-overlay__close').show();
                if(response.Success) {
                    $(overlayId).find('.h-response-message--success').show();
                    $triggerEl.css({'opacity': '0.6', 'cursor': 'not-allowed'}).attr('disabled', 'disabled');
                } else {
                    $(overlayId).find('.h-response-message--error').show().append('<p>' + response.Message + '</p>');
                }
            },
            error: (xhr, status, error) => {
                $(overlayId).find('.c-overlay__close').show();
                $(overlayId).find('.c-spinner').hide();
                $(overlayId).find('.h-response-message--error').show().append('<p>' + error + '</p>');
                console.log(error);
            }
        });
    }, 750);
}



// WEBPACK FOOTER //
// ./src/app/components/admin-email/admin-email.js